import { getEnv } from "../helpers/general";

export const APP_VERSION = getEnv("REACT_APP_VERSION") || "unknown";
export const BUILD_NUMBER = getEnv("REACT_APP_ENVIRONMENT") || "unknown";
export const COMPANY_PHONE = "02172176";
